const rankingItems = [
  { rank: 1, title: '某顶流男星深夜与神秘女子同回公寓', heat: '980万', trend: 'up', change: '↑ 3位' },
  { rank: 2, title: '知名导演被多名女演员实名举报', heat: '876万', trend: 'up', change: '↑ 5位' },
  { rank: 3, title: '热门综艺录制现场导演与嘉宾爆发激烈争吵', heat: '743万', trend: 'up', change: '↑ 1位' },
  { rank: 4, title: '影视公司内部邮件曝光资本运作黑幕', heat: '621万', trend: 'new', change: '新上榜' },
  { rank: 5, title: '某女星社交媒体小号发文疑似回应争议', heat: '508万', trend: 'down', change: '↓ 2位' },
  { rank: 6, title: '经纪公司连夜发声明否认旗下艺人合约纠纷', heat: '435万', trend: 'down', change: '↓ 4位' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            热搜榜单
          </h2>
          <p className="text-sm text-foreground-500">实时更新全网最热爆料话题排行</p>
        </div>

        <div className="space-y-2">
          {rankingItems.map((item) => (
            <a
              key={item.rank}
              href="#ranking"
              className="flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-200 hover:bg-primary-50/30 transition-all cursor-pointer group"
            >
              <div className={`flex-shrink-0 w-9 h-9 rounded-lg flex items-center justify-center font-heading font-bold text-sm ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-primary-400 text-background-50'
                  : item.rank === 3
                  ? 'bg-accent-500 text-foreground-950'
                  : 'bg-secondary-100 text-secondary-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </p>
              </div>

              <div className="flex-shrink-0 flex items-center gap-3">
                <span className={`text-[10px] font-medium px-1.5 py-0.5 rounded whitespace-nowrap ${
                  item.trend === 'up'
                    ? 'text-primary-600 bg-primary-50'
                    : item.trend === 'new'
                    ? 'text-accent-700 bg-accent-50'
                    : 'text-secondary-600 bg-secondary-50'
                }`}>
                  {item.change}
                </span>
                <div className="text-right min-w-[60px]">
                  <span className="text-xs font-semibold text-accent-600 whitespace-nowrap">
                    <i className="ri-fire-fill text-[10px] mr-0.5"></i>{item.heat}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a href="#ranking" className="inline-flex items-center gap-2 px-5 py-2.5 bg-secondary-100 text-secondary-700 rounded-lg hover:bg-secondary-200 transition-colors text-sm font-medium cursor-pointer">
            <span>查看完整榜单</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}